module['exports'] = ['ٹاوْن'];
